// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k2jwz","footer":"styles_footer__15wp1","passCodeTooltip":"styles_passCodeTooltip__1RTTW"};